module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Mono.ce58835e.eot";